var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 112.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,24.6l-13.8,16v8.1H25v-5.8h12.9V28h27.2v20.7h3.4V24.6H35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,73.5h40.1v11H25V73.5z M40.9,55.7h2.8v11h6.7v2.5h-9.5V55.7z M27,55.7h3.3l2.4,4.4l2.5-4.4h3.3l-4.1,6.5 l4.4,7h-3.4l-2.6-4.6L30,69.2h-3.3l4.4-6.9L27,55.7z M57.6,55.2c1.5,0,3.1,0.4,4.1,1.5c0.8,0.8,1.2,1.8,1.2,2.9h-2.7 c0-0.9-0.7-1.8-1.6-1.9c-1-0.2-2.1-0.2-2.9,0.3c-0.8,0.5-0.8,1.9,0.1,2.4c1.1,0.6,2.3,0.7,3.4,1c1.2,0.4,2.5,0.7,3.4,1.6 c0.8,1,0.9,2.5,0.6,3.7c-0.4,1.4-1.8,2.4-3.2,2.7c-1.4,0.3-2.9,0.3-4.3-0.1c-1.4-0.3-2.7-1.2-3.2-2.7c-0.1-0.4-0.3-1.5-0.3-1.5H55 c0,1,0.8,1.9,1.8,2.1s2.2,0.2,3.1-0.3c0.8-0.5,1-1.7,0.4-2.4c-0.8-0.7-1.9-0.8-2.9-1c-1.4-0.4-3-0.7-4-1.9c-0.8-1-0.9-2.3-0.6-3.5 c0.4-1.6,1.9-2.5,3.4-2.8C56.6,55.2,57.1,55.2,57.6,55.2z M17.7,51.3v22.2h3.9v14.4h46.9V73.5h3.9V51.3H17.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.537c4d14ff50365d592c962be80ffb92.svg";
export { ForwardRef as ReactComponent };